import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class CrmBrandService {
  private readonly baseUrl = '/api/crm/brands';

  constructor(
    private httpService: HttpService,
    private constantsService: ConstantsService
  ) {}

  getBrands(clientKey?: number): Observable<any> {
    let url = this.baseUrl;
    if (clientKey) {
      url += `?clientKey=${clientKey}`;
    }
    const requestData = {
      API_URL: url,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestData);
  }

  getBrandById(id: number): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestData);
  }

  createBrand(brandPayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST,
      BODY: brandPayload
    };
    return this.httpService.sendRequest(requestData);
  }

  updateBrand(id: number, brandPayload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_PUT,
      BODY: brandPayload
    };
    return this.httpService.sendRequest(requestData);
  }
}
